import { render, staticRenderFns } from "./StatisticCard.vue?vue&type=template&id=2e3a6714"
import script from "./StatisticCard.vue?vue&type=script&lang=js"
export * from "./StatisticCard.vue?vue&type=script&lang=js"
import style0 from "./StatisticCard.vue?vue&type=style&index=0&id=2e3a6714&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports